import CardContainer from "@/Component/Elements/CardContainer/CardContainer";
import useFileDataStore from "../../hooks/useFileInfoListStore.store";
import CSS from "./static/css/SelectImageVersion.module.css";

export default function SelectImageVersion() {
    const {
        fileInfoList,
        selected_index,
        setSelectedIndex,
        is_disabled,
    } = useFileDataStore();

    return(
        <CardContainer class_name_list={[CSS.SelectImageVersion]}>
            {
                fileInfoList.map((item, index) => {
                    return (
                        <div key={index}>
                            <input
                                type="radio"
                                id={`image-version-${index}`}
                                checked={selected_index === index}
                                onChange={() => setSelectedIndex(index)}
                                disabled={is_disabled}
                            />
                            <label
                                htmlFor={`image-version-${index}`}
                                className={is_disabled ? "disabled" : ""}
                            >
                                    {item.upload_date} 업로드 {item.is_can_download ? "" : "(다운로드 불가)"}
                            </label>
                        </div>
                    )
                })
            }
        </CardContainer>
    )
}